<template>
    <div>
        <div class="container mx-auto py-1 text-center">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {};
</script>
